import { Typography, Stack, SxProps } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { titleSX } from '@/components/blocks/GroupAccordionPageLink/styles';
import { CustomAccordion } from '@/components/blocks/GroupAccordionPageLink/parts/CustomAccordion';
import { CustomAccordionSummary } from '@/components/blocks/GroupAccordionPageLink/parts/CustomAccordionSummary';
import { CustomAccordionDetails } from '@/components/blocks/GroupAccordionPageLink/parts/CustomAccordionDetails';
import { combineSX } from '@/utils/combineSX';
import { linkSX } from '@/components/blocks/GroupPageLink/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const DpFooterAccordionLinkFrame: React.FC<{
	title: string;
	isfirst?: boolean;
	children: React.ReactNode;
}> = ({ title, isfirst = false, children }) => (
	<CustomAccordion square={true} disableGutters={true} elevation={0} isfirst={isfirst}>
		<CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
			<Typography sx={titleSX}>{title}</Typography>
		</CustomAccordionSummary>
		<CustomAccordionDetails>
			<Stack spacing="14px" mb={2}>
				{children}
			</Stack>
		</CustomAccordionDetails>
	</CustomAccordion>
);

export const DpFooterAccordionLink: React.FC<{
	id?: string;
	href?: string;
	target?: string;
	sx?: SxProps;
	children: React.ReactNode;
}> = ({ id, href, target, sx, children }) => (
	<Linkable data-testid={id} id={id} href={href} sx={combineSX([linkSX, sx])} target={target}>
		{children}
	</Linkable>
);
